<template>
  <div class="upload-doc-row">
    <div class="upload-header">
      <span class="doc-title">{{ documentName }}</span>
      <el-upload ref="upload" v-loading="loading" :headers="uploadHeaders" :disabled="cntrldisabled"
        :action="cntrluploadapi" :list-type="listtype" :auto-upload="cntrlautoupload" multiple :limit="60"
        :file-list="fileList" :on-preview="onPreview2" :before-upload="beforeUpload" :on-success="afterUpload"
        :on-remove="handleRemove" :accept="listtype === 'text' ? docOnly : imageonly" :show-file-list="false"
        class="upload-root">
        <template #trigger>
          <el-button v-if="showTrigger && !cntrldisabled" type="primary" circle class="upload-plus">
            <i class="fa fa-plus"></i>
          </el-button>
        </template>
      </el-upload>
    </div>
    <ul class="file-list-custom">
      <li v-for="file in fileList" :key="file.id" class="file-row">
        <i :class="fileIcon(file.name)" class="file-icon" :style="{ color: fileColor(file.name) }"></i>
        <a :href="file.urlorig" :download="file.name" target="_blank" class="file-link">
          {{ displayFileName(file.name) }}
        </a>
        <el-button v-if="!cntrldisabled" type="text" :icon="DeleteIcon" size="small" @click="handleRemove(file, $event)"
          class="file-delete">
        </el-button>
      </li>
    </ul>
  </div>
</template>

<script>
import { Delete as DeleteIcon } from "@element-plus/icons-vue";
import { GenerateHex } from "../Source/crypto";
import { api, fileurl } from "../Source/helper";
import { Create, GetFiles, Delete } from "../Source/files";
import { FileType } from "../Source/types";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import saveAs from "save-as";
export default {
  name: "upload",
  props: {
    documentName: { type: String, default: "" },
    showTrigger: { type: Boolean, default: true },
    sourcetype: Number,
    sourceId: [Number, String],
    uploadapi: { type: String, default: "/" },
    fileurl: { type: String, default: fileurl },
    disabled: { type: Boolean, default: false },
    autoupload: { type: Boolean, default: true },
    listtype: { type: String, default: "picture-card" },
    downloadAll: { type: Boolean, default: false },
    acceptonlyimages: { type: Boolean, default: true },
  },
  data() {
    return {
      DeleteIcon,
      imageonly: ".jpg,.jpeg,.png,.jfif,.mp4,.mkv,.mov,.html,.xhtml,.doc,.xls,.xlsx,.pdf",
      docOnly: ".pdf,.doc,.docx, .html,.xhtml",
      progress: 0,
      fileList: [],
      loading: false,
      downloading: false,
      dialogImageUrl: "",
      dialogVisible: false,
      dialogVideoVisible: false,
      selectedIndex: 0,
      cntrlfileurl: this.fileurl,
      cntrldisabled: this.disabled,
      cntrlautoupload: this.autoupload,
      sid: this.sourceId,
      sdid: this.sourcedetId,
      filecount: 0,
      previewlist: [],
      zip: "",
      count: 0,
      fileURLs: [],
      selectedVideo: "",
      video: ["mp4", "mkv", "mov"],
      videothumb: "https://carep.hu-st.com/_assets/thumb_video.png",
      uid: this.$store.state.user.id,
      downloadableList: [],
      uploadHeaders: {
        Authorization: 'Bearer ' + this.$store.state.user.jwt,
      },
    };
  },
  computed: {
    cntrluploadapi() {
      let requestCorrelationId = crypto.randomUUID();
      return api + "/Upload/" + requestCorrelationId;
    },
  },
  methods: {
    fileIcon(fileName) {
      const ext = fileName.split(".").pop().toLowerCase();
      switch (ext) {
        case "pdf":
          return "fa fa-file-pdf";
        case "doc":
        case "docx":
          return "fa fa-file-word";
        case "xls":
        case "xlsx":
          return "fa fa-file-excel";
        case "ppt":
        case "pptx":
          return "fa fa-file-powerpoint";
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
          return "fa fa-file-image";
        case "zip":
        case "rar":
          return "fa fa-file-zipper";
        case "mp4":
        case "mkv":
        case "mov":
          return "fa fa-file-video";
        default:
          return "fa fa-file";
      }
    },
    fileColor(fileName) {
      const ext = fileName.split(".").pop().toLowerCase();
      switch (ext) {
        case "pdf":
          return "#e53935";
        case "doc":
        case "docx":
          return "#1976d2";
        case "xls":
        case "xlsx":
          return "#388e3c";
        case "ppt":
        case "pptx":
          return "#e67e22";
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
          return "#8e24aa";
        case "zip":
        case "rar":
          return "#616161";
        case "mp4":
        case "mkv":
        case "mov":
          return "#3445db";
        default:
          return "#708090";
      }
    },
    isFileType(fileName, extension) {
      return fileName.endsWith("." + extension);
    },
    isVideo(file) {
      if (!file || !file.rawname) return false;
      let ext = file.rawname.split(".").pop().toLowerCase();
      return this.video.includes(ext);
    },
    submit(sourceId, sourcedetId) {
      this.sid = sourceId;
      this.sdid = sourcedetId;
      this.$refs.upload.submit();
    },
    handleRemove(file, event) {
      if (event && event.stopPropagation) event.stopPropagation();
      if (!file.id) return;

      this.$swal({
        title: "Təsdiq edin",
        text: "Silmək istədiyinizə əminsiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "İmtina",
        confirmButtonText: "Təsdiq et",
        customClass: {
          confirmButton: "btn bg-gradient-info",
          cancelButton: "btn bg-gradient-secondary",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          Delete(file.id, this.uid).then((response) => {
            this.loading = false;
            if (response.data) {
              this.getFiles();
            } else {
              this.$message({ type: "error", message: response.data.message });
            }
          });
        }
      });
    },
    onPreview(file) {
      if (this.listtype === "picture-card") {
        this.selectedIndex = this.fileList.indexOf(file);
        this.dialogVisible = true;
        this.previewlist.push(file.urlorig);
        if (this.$refs.carousel)
          this.$refs.carousel.setActiveItem(this.selectedIndex);
      } else {
        window.open(file.url, "_blank");
      }
    },
    onPreview2(file) {
      let ext = file.rawname.split(".").pop();
      if (this.listtype === "picture-card") {
        if (this.video.includes(ext.toLowerCase())) {
          this.selectedVideo = file.urlorig;
          this.dialogVideoVisible = true;
        } else if (['jpg', 'jpeg', 'png', 'jfif'].includes(ext.toLowerCase())) {
          this.selectedIndex = this.fileList
            .filter((c) => c.url !== this.videothumb)
            .indexOf(file);
          this.dialogVisible = true;
          this.previewlist = [];
          this.fileList
            .filter((c) => c.url !== this.videothumb)
            .forEach((e) => this.previewlist.push(e.urlorig));
        }
      } else {
        window.open(file.urlorig, "_blank");
      }
    },
    beforeUpload(file) {
      let fname = file.name;
      let key = GenerateHex();
      let newname = key + "_" + fname;
      Object.defineProperty(file, "name", {
        writable: true,
        value: newname,
      });
      this.filecount = this.filecount + 1;
    },
    afterUpload(response, file) {
      if (!response.dbPath) return;
      var f = new FileType();
      f.filename = file.raw.name;
      f.sourcetype = this.sourcetype;
      f.sourceId = this.sid;
      f.commandUserId = this.uid;
      this.loading = true;
      Create(f).then((response) => {
        this.loading = false;
        if (response.data.data) {
          this.filecount = this.filecount - 1;
          if (this.filecount === 0) this.getFiles();
          this.$emit("file-uploaded");
        }
      });
    },
    displayFileName(fileName) {
      const extension = fileName.split('.').pop();
      if (['html', 'xhtml', 'doc', 'xls', 'xlsx', 'pdf'].includes(extension)) {
        return fileName.slice(0, -extension.length - 1);
      }
      return fileName;
    },
    getFiles() {
      if (!this.cntrlfileurl) return;
      this.loading = true;

      GetFiles(this.sourcetype, this.sid, null, this.uid).then((response) => {
        this.fillList(response.data);
        this.$emit("filesloaded", this.fileList);
        this.loading = false;
      });
    },
    fillList(files) {
      this.fileList = [];
      this.downloadableList = [];
      if (files === undefined) return;
      let ext = "";
      let url = "";
      for (let i = 0; i < files.length; i++) {
        let fname = files[i].fileName.substring(files[i].fileName.indexOf("_") + 1);
        if (this.listtype === "picture-card") {
          ext = files[i].fileName.split(".").pop();
          let file = {
            name: fname,
            year: files[i].year,
            id: files[i].id,
            rawname: files[i].fileName,
            urlorig: this.fileurl + files[i].year + "/" + files[i].fileName,
          };
          if (['jpg', 'jpeg', 'png', 'jfif', 'mp4', 'mkv', 'mov'].includes(ext.toLowerCase())) {
            if (this.video.includes(ext.toLowerCase())) url = this.videothumb;
            else url = this.fileurl + files[i].year + "/" + files[i].fileName;
            file.url = url;
            this.fileList.push(file);
          }
          if (['pdf', 'xls', 'xlsx', 'html', 'xhtml', 'doc', 'docx'].includes(ext.toLowerCase())) {
            this.downloadableList.push(file);
          }
        } else {
          if (this.video.includes(ext.toLowerCase())) url = this.videothumb;
          else
            url = this.fileurl + files[i].year + "/" + files[i].fileName;
          this.fileList.push({
            name: fname,
            year: files[i].year,
            id: files[i].id,
            rawname: files[i].fileName,
            url: url,
            urlorig: this.fileurl + files[i].year + "/" + files[i].fileName,
          });
        }
      }
    },
    click() {
      this.downloading = true;
      this.download().then(() => {
        this.downloading = false;
      });
    },
    download() {
      return new Promise((resolve) => {
        let urls = [];
        this.fileURLs = [];
        this.fileList.forEach((element) => {
          urls.push(element.urlorig);
        });
        const zip = new JSZip();
        let count = 0;
        const zipFilename = "cm.zip";
        urls.forEach(async function (url) {
          const urlArr = url.split("/");
          const filename = urlArr[urlArr.length - 1];
          try {
            const file = await JSZipUtils.getBinaryContent(url);
            zip.file(filename, file, { binary: true });
            count++;
            if (count === urls.length) {
              zip
                .generateAsync({ type: "blob" })
                .then(function (content) {
                  saveAs(content, zipFilename);
                  resolve(true);
                });
            }
          } catch (err) {
            console.error("Download error:", err);
          }
        });
      });
    },
  },
  mounted() {
    this.uploadHeaders = {
      Authorization: 'Bearer ' + this.$store.state.user.jwt,
    };
    this.getFiles();
  },
  watch: {
    sourceId() {
      this.sid = this.sourceId;
      this.getFiles();
    },
    fileurl() {
      this.cntrlfileurl = this.fileurl;
      this.getFiles();
    },
    uploadapi() {
      if (!this.uploadapi) this.cntrluploadapi = "/";
      this.cntrluploadapi = this.uploadapi;
    },
    autoupload() {
      this.cntrlautoupload = this.autoupload;
    },
    disabled() {
      this.cntrldisabled = this.disabled;
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-doc-row {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.upload-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 6px;
  min-height: 38px;
}

.doc-title {
  color: black !important;
  font-weight: 500 !important;
  font-size: 16px !important;
  line-height: 1.1;
}

.upload-plus {
  width: 20px !important;
  height: 20px !important;
  font-size: 14px !important;
  background: #42aaff !important;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
  margin: 0;
  transition: background 0.2s;
}

.upload-plus:hover {
  background: #3399ff !important;
}

.upload-root {
  margin: 0 !important;
}

.file-list-custom {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

.file-row {
  display: flex;
  align-items: center;
  min-height: 32px;
  gap: 8px;
  font-size: 15px;
  margin-bottom: 3px;
  margin-left: 2px;
  justify-content: space-between;
  width: 100%;
}

.file-icon {
  width: 26px;
  text-align: center;
  flex-shrink: 0;
  font-size: 18px;
}

.file-link {
  color: #176ab5;
  text-decoration: underline;
  transition: color 0.2s;
  min-width: 0;
  max-width: 170px;
  flex: 0 1 auto;
  margin-right: auto;
  word-break: break-all;
  display: block;
}

.file-delete {
  color: red !important;
  font-size: 16px !important;
  margin-left: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
}

.file-row:hover {
  background: #e4e6ec;
  box-shadow: 0 1px 7px 0 #bbb3;
  border-radius: 5px;
}

.file-link {
  color: #176ab5;
  text-decoration: underline;
  transition: color 0.2s;
}

::v-deep(.el-icon--close-tip) {
  display: none !important;
}
</style>
